 /**
 * 海关编码-设置页 | 选择证书
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
 import React,{Fragment, PureComponent} from "react"
 import Lang from "@components/Lang/Lang";
 import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
 import {Input,Modal,Button} from 'antd'
 import dayjs from 'dayjs';
 import './Certificate.less'

 
 export default class Certificate extends PureComponent {
     constructor(props) {
         super(props)
         this.state = {
            modalVisible:false,
            rowSelection:{},
            selectedRows:this.props.selectedRows || [],
            columns : [
                 {
                     title: 'data',
                     dataIndex: 'id',
                     render: (text,record) => {
                         return (<Fragment>
                                 <div style={{marginBottom:'10px'}}>
                                     <b>{record.code}</b>
                                 </div>
                                 <div>
                                    <span className={record.isExpired?'isExpired-yes':'isExpired-no'}>
                                    {Lang({id: 'YouXiaoQiZhi', default: '有效期至'})} {record.effectiveEndTime?(dayjs(record.effectiveEndTime).format('YYYY-MM-DD')):'-'}  {record.isExpired?'已过期':''}
                                    </span>
                                     {
                                         record.categoryList.map(item => {
                                             return <span className="category">{item.categoryName}</span>
                                         })
                                     }
                                 </div>
                                 <div className="remark">
                                    {record.remark || '-'}
                                </div>
                         </Fragment>)
                     }
                 }
             ],
            searchFormOptions:[
                 {
                     name:'keyword',
                     cnPlaceholder:'请输入证书编号/备注搜索',
                     cnPlaceholderId:'QingShuRuZhengShuBianHao',
                     width:400
                 },
             ],
         }
     }
    /*
    * 打开
    * */
     open = (flag=true) => {
         if(flag){
             this.getSelect()
         }else {
             this.setState({
                 modalVisible:flag,
             },()=>this.setState({
                 tableVisible:false
             }))
         }
     }
     handleOk () {
         const { selectedRows=[]} = this.state;
         this.props.callBack(selectedRows.filter(item=>item&&item.id));
         this.open(false)
     }
     // 获取所选条
     getSelect() {
         let selectedRows = [],selectedRowKeys=[];
         const {goodsCertificateList=[] } = this.props;
         if(goodsCertificateList&&goodsCertificateList.length>0){
               goodsCertificateList.forEach(value => {
                  selectedRows.push({
                      saleGoodsCertificateId:value.saleGoodsCertificateId,
                      code:value.code,
                      id:value.id
                  })
                  selectedRowKeys.push(value.id)
             })
         }
        this.setState({
            // rowSelection:rowSelection,
            selectedRowKeys:selectedRowKeys,
            selectedRows:selectedRows,
            modalVisible:true,
        },() => {
            this.setState({
                tableVisible:true
            })
        })
     }
     onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
     fetchCallBack(res){

     }
     onSelectChange = (newSelectedRowKeys=[],seRows=[]) => {
         seRows.map(item=>item.saleGoodsCertificateId = item.id);
         this.setState({
             selectedRowKeys:newSelectedRowKeys,
             selectedRows:seRows,
         })
     };
     componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
     }
     render() {
         const {categoryId} = this.props;
        const {modalVisible,columns,searchFormOptions,tableVisible=false,selectedRowKeys,selectedRows} = this.state;
        return (
            <div style={{float:'left'}}>
               <Modal
                    forceRender={true}
                    destroyOnClose={true}
                    open={modalVisible} 
                    title={Lang({id: 'XuanZeZhengShu', default: '选择证书'})}
                    width={660}
                    onCancel={()=>this.open(false)}
                    onOk={()=>this.handleOk(true)}>
                   <div className="popCerModal">
                        {tableVisible&&<AutoFetchTable columns={columns}
                                                       rowSelection={{
                                                           selectedRowKeys,
                                                           selectedRows,
                                                           onChange: (selectedRowKeys,selectedRows)=>this.onSelectChange(selectedRowKeys,selectedRows),
                                                       }}
                                                      showHeader={false}
                                                      pageSize={50}
                                                      precondition={{
                                                          categoryId:categoryId
                                                      }}
                                                       scrollTop={false}
                                                      scroll={{y:450}}
                                                    onRef={this.onRefTabOne}
                                                    fetchCallBack={(res)=>this.fetchCallBack(res)}
                                                    flagShowReset={false}
                                                    searchFormOptions={searchFormOptions}
                                                    fetchApi={'/service/mg/certificate/query-list'} />}
                   </div>
                </Modal>
                <span onClick={(e) => this.open()}>
                    {this.props.children}
                </span>

            </div>


        )
     }
 }

 